import script from "./LocalCharaDatabase.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalCharaDatabase.vue?vue&type=script&setup=true&lang=js"

import "./LocalCharaDatabase.vue?vue&type=style&index=0&id=32f33418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f33418"]])

export default __exports__